module.exports = __webpack_public_path__ + "img/arrow-up.c80685c6.svg";